const urls = {
  base: '/login/',
};

export function loginUrl(): string {
  return urls.base;
}

export default urls;
